import React, { useState } from "react";
import PageWrapper from "pages/common/PageWrapper";
import styled from "styled-components";
import { Tabs, Tab, TabsList, TabPanel } from "design-system";
import General from "./General";
import GitConfig from "./GitConfig";
import { useLocation } from "react-router";
import { GIT_PROFILE_ROUTE } from "constants/routes";
import { BackButton } from "components/utils/helperComponents";

const ProfileWrapper = styled.div`
  width: 978px;
  margin: 64px auto;
  padding-left: var(--ads-v2-spaces-7);

  .tab-item {
    display: flex;
    gap: 5px;
    align-items: center;
  }
`;

const TabsListWrapper = styled(TabsList)`

  /* 使用最高优先级的选择器强制覆盖 */
  &&& .ads-v2-tabs__list::after,
  &&& .ads-v2-tab::after,
  &&& ::after,
  &&& [role="tablist"]::after,
  &&& [role="tab"]::after {
    background: var(--tab-selection-color) !important;
  }

  &&& .ads-v2-tab[data-state="active"]::after,
  &&& .ads-v2-tab[aria-selected="true"]::after,
  &&& button[role="tab"][aria-selected="true"]::after {
    background: var(--ads-color-brand-tab-selection) !important;
  }

  &&& .ads-v2-tab:hover::after,
  &&& button[role="tab"]:hover::after {
    background: var(--ads-color-brand-tab-selection) !important;
  }
`;

function UserProfile() {
  const location = useLocation();

  let initialTab = "general";
  const tabs = [
    {
      key: "general",
      title: "基本信息",
      panelComponent: <General />,
      icon: "general",
    },
  ];

  tabs.push({
    key: "gitConfig",
    title: "Git 用户信息",
    panelComponent: <GitConfig />,
    icon: "git-branch",
  });
  if (location.pathname === GIT_PROFILE_ROUTE) {
    initialTab = "gitConfig";
  }

  const [selectedTab, setSelectedTab] = useState(initialTab);

  return (
    <PageWrapper displayName={"个人信息"}>
      <ProfileWrapper>
        <BackButton />
        <Tabs defaultValue={selectedTab} onValueChange={setSelectedTab}>
          <TabsListWrapper>
            {tabs.map((tab) => {
              return (
                <Tab key={tab.key} value={tab.key}>
                  <div className="tab-item">{tab.title}</div>
                </Tab>
              );
            })}
          </TabsListWrapper>
          {tabs.map((tab) => {
            return (
              <TabPanel key={tab.key} value={tab.key}>
                {tab.panelComponent}
              </TabPanel>
            );
          })}
        </Tabs>
      </ProfileWrapper>
    </PageWrapper>
  );
}

export default UserProfile;
